/* eslint-disable no-new */
import store from '@/store'

export default {
  store,
  install (Vue) {
    const Modal = {
      confirm (
        text = 'Mensaje...',
        callbackOk,
        callbackCancel,
        withCancel = true,
        textOk = 'Aceptar',
        textCancel = 'Cancelar',
        width = 360
      ) {
        const { confirm } = store.state
        confirm.show = true
        confirm.text = text
        confirm.width = width
        confirm.textOk = textOk
        if (withCancel) {
          confirm.textCancel = textCancel
        }

        if (typeof callbackOk === 'function') {
          confirm.callbackOk = callbackOk
        }

        if (typeof callbackCancel === 'function') {
          confirm.callbackCancel = callbackCancel
        }
      }
    }
    Vue.prototype.$confirm = Modal.confirm
  }
}



// WEBPACK FOOTER //
// ./src/common/plugins/Modal/modal.js